import React, { ReactNode } from "react";

interface TicketPanelLayoutProps {
  headerLeft: ReactNode;
  headerRight?: ReactNode;
  children: ReactNode;
}

export function TicketPanelLayout({ headerLeft, headerRight, children }: TicketPanelLayoutProps) {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex h-12 shrink-0 items-center justify-between border-b border-grey-200 px-4">
        {headerLeft}
        {headerRight}
      </div>
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
    </div>
  );
}
